import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { CommonModule } from '@angular/common';
import { OpsOrganisationSettingsComponent } from '../ops-organisation-settings/ops-organisation-settings.component';
import { OpsPaymentMethodsComponent } from '../ops-payment-methods/ops-payment-methods.component';
import { OpsProfileSettingsComponent } from '../ops-profile-settings/ops-profile-settings.component';
import { OpsSecuritySettingsComponent } from '../ops-security-settings/ops-security-settings.component';
import { OpsTeamMemberComponent } from '../ops-team-member/ops-team-member.component';
import { OpsSettingsComponent } from './ops-settings.component';
import { OpsProfileSettingsModule } from '../ops-profile-settings/ops-profile-settings.module';
import { OpsOrganisationSettingsModule } from '../ops-organisation-settings/ops-organisation-settings.module';
import { OpsPaymentMethodsModule } from '../ops-payment-methods/ops-payment-methods.module';
import { NgxsModule } from '@ngxs/store';
import { SettingsEditState } from '@ops/services';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { OpsTeamMemberModule } from '../ops-team-member/ops-team-member.module';
import { OpsSecuritySettingsModule } from '../ops-security-settings/ops-security-settings.module';
import { OpsSubscriptionSettingsComponent } from '../ops-subscription-settings/ops-subscription-settings.component';
import { OpsSubscriptionSettingsModule } from '../ops-subscription-settings/ops-subscription-settings.module';
import { TranslateModule } from '@ngx-translate/core';

export const routes: Routes = [
  {
    path: '',
    component: OpsSettingsComponent,
    children: [
      {
        path: 'profile-settings',
        component: OpsProfileSettingsComponent,
      },
      {
        path: 'organization-settings',
        component: OpsOrganisationSettingsComponent,
      },
      { path: 'team-member', component: OpsTeamMemberComponent },
      { path: 'payment-methods', component: OpsPaymentMethodsComponent },
      { path: 'security', component: OpsSecuritySettingsComponent },
      { path: 'my-subscriptions', component: OpsSubscriptionSettingsComponent },
      { path: '', redirectTo: 'profile-settings', pathMatch: 'full' }, // Default route
    ],
  },
];

@NgModule({
  declarations: [OpsSettingsComponent],
  imports: [
    CommonModule,
    OpsProfileSettingsModule,
    OpsOrganisationSettingsModule,
    OpsPaymentMethodsModule,
    OpsTeamMemberModule,
    OpsSecuritySettingsModule,
    OpsSubscriptionSettingsModule,
    RouterModule.forChild(routes),
    NgxsModule.forRoot([SettingsEditState]),
    NgxsReduxDevtoolsPluginModule.forRoot(),
    TranslateModule,
  ],
  exports: [RouterModule],
})
export class OpsSettingsModule {}
